// Icons
import {
  AppsOutlined as AppsIcon,
  AssignmentOutlined as AssignmentIcon,
  HomeOutlined as HomeIcon,
  LiveTv as LiveTvIcon,
  SettingsOutlined as SettingsIcon,
  VerifiedUserOutlined as VerifiedUserOutlinedIcon,
} from "@mui/icons-material";

// Pages
import {
  ConfigurationList,
  CountryDetail,
  CountryList,
  EventDetail,
  EventList,
  EventPlaylist,
  EventSchedule,
  EventStreams,
  EventTypeDetail,
  EventTypeList,
  GameDetail,
  GameList,
  NewsDetail,
  NewsList,
  Overview,
  PlayerDetail,
  PlayerList,
  PremiumOrderList,
  PremiumOrderDetail,
  SlideDetail,
  SlideList,
  SportDetail,
  SportList,
  UserDetail,
  UserList,
  VideoDetail,
  VideoList,
  EventRankings,
  EquipmentList,
  SponsorDetail,
  SponsorList,
  EquipmentDetail,
  AntMediaImportVideos,
  StreamConsole,
  AudienceReports,
  CouponList
} from "./pages";
import apiEndpoints from "constants/endpoints";

export const URL_ADMIN = "/";
const routes = {
  items: [
    {
      path: URL_ADMIN,
      name: "Dashboard",
      type: "submenu",
      icon: AppsIcon,
      sidebarBackgroundColor: "#302d2b",
      children: [
        {
          path: "",
          name: "Overview",
          component: Overview,
          sidebarBackgroundColor: "#302d2b",
        },
        {
          path: apiEndpoints.audienceReports,
          name: "Audience Reports",
          component: AudienceReports,
          sidebarBackgroundColor: "#302d2b",
        },
      ]
    },
    {
      path: URL_ADMIN,
      name: "Home",
      type: "submenu",
      icon: HomeIcon,
      sidebarBackgroundColor: "#02023c",
      children: [
        {
          path: apiEndpoints.slides,
          name: "Slides",
          component: SlideList,
          sidebarBackgroundColor: "#20205e",
        },
        {
          path: `${apiEndpoints.slides}/:id`,
          name: "Slide Detail",
          component: SlideDetail,
          sidebarBackgroundColor: "#20205e",
          invisibleOnSidebar: true,
        },
      ],
    },
    {
      path: URL_ADMIN,
      name: "News",
      type: "submenu",
      icon: AssignmentIcon,
      sidebarBackgroundColor: "#fdc209",
      children: [
        {
          path: apiEndpoints.news,
          name: "Articles",
          component: NewsList,
          sidebarBackgroundColor: "#f0b830",
        },
        {
          path: `${apiEndpoints.news}/:id`,
          name: "Edit Article",
          component: NewsDetail,
          sidebarBackgroundColor: "#f0b830",
          invisibleOnSidebar: true,
        },
        {
          path: apiEndpoints.players,
          name: "Players",
          type: "link",
          component: PlayerList,
          sidebarBackgroundColor: "#f0b830",
        },
        {
          path: `${apiEndpoints.players}/:id`,
          name: "Edit Player",
          type: "link",
          component: PlayerDetail,
          sidebarBackgroundColor: "#f0b830",
          invisibleOnSidebar: true,
        },
      ],
    },
    {
      path: URL_ADMIN,
      name: "TV",
      type: "submenu",
      icon: LiveTvIcon,
      sidebarBackgroundColor: "#e51135",
      children: [
        {
          path: apiEndpoints.events,
          name: "Events",
          component: EventList,
          sidebarBackgroundColor: "#e0365b",
        },
        {
          path: `${apiEndpoints.events}/:id`,
          name: "Event Detail",
          component: EventDetail,
          invisibleOnSidebar: true,
        },
        {
          path: `${apiEndpoints.eventVideos}/:eventId`,
          name: "Event Playlist",
          component: EventPlaylist,
          invisibleOnSidebar: true,
        },
        {
          path: `${apiEndpoints.eventDays}/:eventId`,
          name: "Event Schedule",
          component: EventSchedule,
          invisibleOnSidebar: true,
        },
        {
          path: `${apiEndpoints.rankings}/:eventId`,
          name: "Event Rankings",
          component: EventRankings,
          invisibleOnSidebar: true,
        },
        {
          path: `${apiEndpoints.streams}/:eventId`,
          name: "Event Streams",
          component: EventStreams,
          invisibleOnSidebar: true,
        },
        {
          path: `${apiEndpoints.videos}/:videoId`,
          name: "Video Detail",
          component: VideoDetail,
          invisibleOnSidebar: true,
        },
        {
          path: apiEndpoints.videos,
          name: "Videos",
          component: VideoList,
          sidebarBackgroundColor: "#e0365b",
        },
        {
          path: "ant-media-import-videos",
          name: "Ant Media Import Videos",
          component: AntMediaImportVideos,
          sidebarBackgroundColor: "#e0365b",
        },
        {
          path: "stream-console",
          name: "Stream Console",
          component: StreamConsole,
          sidebarBackgroundColor: "#e0365b",
        },
        {
          path: apiEndpoints.orders,
          name: "Premium Orders",
          component: PremiumOrderList,
          sidebarBackgroundColor: "#e0365b",
        },
        {
          path: `${apiEndpoints.orders}/:id`,
          name: "Premium Order Detail",
          component: PremiumOrderDetail,
          sidebarBackgroundColor: "#e0365b",
          invisibleOnSidebar: true,
        },
      ],
    },
    {
      path: URL_ADMIN,
      name: "Settings",
      type: "submenu",
      icon: SettingsIcon,
      sidebarBackgroundColor: "#302d2b",
      children: [
        {
          path: apiEndpoints.configurations,
          name: "Configurations",
          component: ConfigurationList,
        },
        {
          path: apiEndpoints.coupons,
          name: "Coupons",
          component: CouponList,
        },
        {
          path: apiEndpoints.sports,
          name: "Sports",
          component: SportList,
        },
        {
          path: `${apiEndpoints.sports}/:id`,
          name: "Sport Detail",
          component: SportDetail,
          invisibleOnSidebar: true,
        },
        {
          path: apiEndpoints.games,
          name: "Games",
          component: GameList,
        },
        {
          path: `${apiEndpoints.games}/:id`,
          name: "Game Detail",
          component: GameDetail,
          invisibleOnSidebar: true,
        },
        {
          path: apiEndpoints.countries,
          name: "Countries",
          component: CountryList,
        },
        {
          path: `${apiEndpoints.countries}/:id`,
          name: "Country Detail",
          component: CountryDetail,
          invisibleOnSidebar: true,
        },
        {
          path: apiEndpoints.eventTypes,
          name: "Event Types",
          component: EventTypeList,
        },
        {
          path: `${apiEndpoints.eventTypes}/:id`,
          name: "Event Type Detail",
          component: EventTypeDetail,
          invisibleOnSidebar: true,
        },
        {
          path: apiEndpoints.equipments,
          name: "Equipments",
          component: EquipmentList,
        },
        {
          path: `${apiEndpoints.equipments}/:id`,
          name: "Equipment Detail",
          component: EquipmentDetail,
          invisibleOnSidebar: true,
        },
        {
          path: apiEndpoints.sponsors,
          name: "Sponsors",
          component: SponsorList,
        },
        {
          path: `${apiEndpoints.sponsors}/:id`,
          name: "Sponsor Detail",
          component: SponsorDetail,
          invisibleOnSidebar: true,
        }
      ],
    },
    {
      path: URL_ADMIN,
      name: "Admins & Users",
      type: "submenu",
      icon: VerifiedUserOutlinedIcon,
      sidebarBackgroundColor: "#302d2b",
      children: [
        {
          path: apiEndpoints.users,
          name: "Users",
          component: UserList,
        },
        {
          path: `${apiEndpoints.users}/:id`,
          name: "User Detail",
          component: UserDetail,
          invisibleOnSidebar: true,
        },
      ],
    },
  ],
};

export default routes;
